<template>
  <div class="dialog_box">
    <el-dialog
      :title="!data ? '新增角色' : '编辑角色'"
      :visible="show"
      width="437px"
      @close="dialogClose"
      top="20vh"
      :close-on-click-modal="false"
    >
      <div class="dialog_container">
        <el-form
          ref="form"
          class="form_box"
          :model="form"
          label-width="80px"
          :rules="rules"
        >
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              v-model="form.roleName"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="角色状态" prop="status">
            <el-switch
              v-model="form.status"
              :active-value="0"
              :inactive-value="1"
              active-color="#7490EB"
              inactive-color="#E7E7E7"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="备注" prop="roleDesc">
            <el-input
              v-model="form.roleDesc"
              type="textarea"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      form: {},
      imgUrl: "",
      stateList: [],
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择角色状态", trigger: "change" },
        ],
        roleDesc: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
    };
  },
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    show(val) {
      if (val) {
        switch (this.type) {
          case 0:
            this.$set(this.form, "roleName", "");
            this.$set(this.form, "status", 0);
            this.$set(this.form, "roleDesc", "");
            this.$set(this.form, "roleId", null);
            break;

          case 1:
            this.$set(this.form, "roleName", this.data.roleName);
            this.$set(this.form, "status", this.data.status);
            this.$set(this.form, "roleDesc", this.data.roleDesc);
            this.$set(this.form, "roleId", this.data.roleId);
            break;
        }
      }
    },
  },
  created() {},
  methods: {
    dialogClose() {
      this.$emit("update:show", false);
    },
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        if (this.type === 0) {
          this.$http.addRole(this.form).then((res) => {
            if (res.code === 0) {
              // this.$message.success(res.msg);
              this.$parent.getList();
              this.$emit("update:show", false);
            }else{
              this.$message.error(res.msg);
            }
          });
        }else{
          this.$http.updateRole(this.form).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg);
              this.$parent.getList();
              this.$emit("update:show", false);
            }else{
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";
/deep/.el-dialog__body {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user_Admin/component/addRedactRoleAdmin.vue